import { render, staticRenderFns } from "./page-config.vue?vue&type=template&id=5db45f32&scoped=true"
import script from "./page-config.vue?vue&type=script&lang=js"
export * from "./page-config.vue?vue&type=script&lang=js"
import style0 from "./page-config.vue?vue&type=style&index=0&id=5db45f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db45f32",
  null
  
)

export default component.exports